import autismDiagnosisQuestionSet from "../faq/autismDiagnosis/allQuestions";

export const asdDiagnosis = {
    'meta': {
        'title': 'Diagnostyka ASD u dorosłych #cityLocativeIn# • Centrum COLLIGO',
        'description': 'Diagnoza ASD u dorosłych to kompleksowy proces 3–6 spotkań, podczas których zbierane są szczegółowe informacje o historii, trudnościach i relacjach społecznych, przeprowadzana jest obserwacja ADOS-2, konsultowana hipoteza diagnostyczna, a następnie wdrażane są dalsze kroki wsparcia i podstawowa psychoedukacja.'
    },
    'availability': [
        'torun'
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/diagnostyka-asd/',
        'title': 'Diagnostyka ASD u dorosłych #cityLocativeIn#',
        'name': 'Diagnostyka ASD u dorosłych #cityLocativeIn#',
        'heading': 'Diagnostyka ASD u dorosłych #cityLocativeIn#',
        'fullName': 'Diagnostyka ASD u dorosłych'
    },
    'image': {
        'url': '/images/services/diagnostyka-asd-w-toruniu.webp',
        'width': 886,
        'height': 295,
        'alt': 'Diagnostyka ASD u dorosłych #cityLocativeIn#'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/open-graph/diagnostyka-asd-w-toruniu.webp',
            'width': 886,
            'height': 295,
            'alt': 'Diagnostyka ASD u dorosłych #cityLocativeIn#'
        }
    },
    'faq': autismDiagnosisQuestionSet
}